import React from 'react';

import RetinaImage from 'react-retina-image';

//import pbh from '../../images/pbh.svg';

const LoginBanner = () => {
  let clientLogo = window.whiteLabel.logoMain;
  return (
    <section className="splash container">
      <div className="row justify-content-md-center">
        <div className="col-lg-6 table-cell align-bottom">
          <div className="col-lg-12 container-logo">
            <RetinaImage className="logo img-fluid" src={clientLogo} />
          </div>
          <p className="heading header">
            { window.whiteLabel.slogan }
          </p>
        </div>
      </div>  
      {/* <div className="row pt-4">
        <div className="col-lg-12">
          <RetinaImage className="pbh-logo img-fluid" src={pbh} />
        </div>
      </div> */}
    </section>
  );
};

export default LoginBanner;


// WEBPACK FOOTER //
// ./src/components/login/LoginBanner.js